(() => {
  const init = () => {
    const button = document.querySelector('[data-whatsapp-support]');
    if (!button || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    const number = button.dataset.number.replace(/\D/g, '').replace(/^00/, '');
    if (!/^[1-9]\d{6,14}$/.test(number)) { button.hidden = true; return; }
    button.href = `https://wa.me/${number}?text=${encodeURIComponent(button.dataset.message || '')}`;
    let frame;
    const visible = el => {const r=el.getBoundingClientRect();const s=getComputedStyle(el);return r.width>0&&r.height>0&&s.display!=='none'&&s.visibility!=='hidden'&&s.opacity!=='0'&&r.bottom>0&&r.top<innerHeight;};
    const update = () => {
      frame = null;
      const overlay = [...document.querySelectorAll('cart-drawer.active, details.menu-opening, details-modal details[open], dialog[open], .shopify-pc__banner, #shopify-pc__banner, #shopify-pc__prefs, [role="dialog"][aria-modal="true"]')].some(visible);
      const keyboard = window.visualViewport && innerHeight - visualViewport.height > 150;
      if (keyboard || overlay) {button.hidden=true;return;}
      // Measure the intended location even after hiding to avoid scroll flicker.
      const mobile=matchMedia('(max-width:749px)').matches;
      const size=mobile?48:52;
      const right=mobile?14:18;
      const offset=parseFloat(button.style.getPropertyValue('--wa-offset'))||24;
      const area={left:innerWidth-right-size-8,right:innerWidth,top:innerHeight-offset-size-20,bottom:innerHeight};
      const overlaps=[...document.querySelectorAll('.product-form__buttons, .cart__ctas, .cart__checkout-button, .sticky-add-to-cart, [data-sticky-add-to-cart], input:not([type="hidden"]), textarea, select, .footer__copyright, .preview-footer small')].some(el=>{if(!visible(el))return false;const r=el.getBoundingClientRect();return r.left<area.right&&r.right>area.left&&r.top<area.bottom&&r.bottom>area.top;});
      button.hidden=overlaps;
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
    document.addEventListener('toggle',schedule,true);document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
    window.visualViewport?.addEventListener('resize',schedule,{passive:true});
    new MutationObserver(m=>{if(m.some(x=>!button.contains(x.target)))schedule();}).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden','style']});
    schedule();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
